import { render } from "./Col.vue?vue&type=template&id=94b27f62"
import script from "./Col.vue?vue&type=script&lang=js"
export * from "./Col.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Layout/Col.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "94b27f62"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('94b27f62', __exports__)) {
    api.reload('94b27f62', __exports__)
  }
  
  module.hot.accept("./Col.vue?vue&type=template&id=94b27f62", () => {
    api.rerender('94b27f62', render)
  })

}


export default __exports__